import type { VistaCard } from "../contratos";

import estilos from "./card.module.css";
import { Bloco, Externo } from "./util";

/** O que o outro lado realmente pensa: pesquisa de opinião curada, como foi publicada. */
export function OutroLado({ vista, numero }: { vista: VistaCard; numero: number }) {
  const linhas = vista.outro_lado ?? [];
  const primeira = linhas[0];
  if (!primeira) return null;
  return (
    <Bloco numero={numero} titulo="O que o outro lado realmente pensa">
      <table>
        <caption>
          {primeira.instituto}, {primeira.data}:{" "}
          {primeira.pergunta_literal === false
            ? `${primeira.pergunta} (como a reportagem descreve a pergunta)`
            : `“${primeira.pergunta}”`}
        </caption>
        <thead>
          <tr>
            <th scope="col">Grupo</th>
            <th scope="col">Resposta</th>
            <th scope="col">Percentual</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((o) => (
            <tr key={`${o.grupo}|${o.resposta}`}>
              <td>{o.grupo}</td>
              <td>{o.resposta}</td>
              <td>{o.percentual}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className={estilos.fonte}>
        Fonte: <Externo href={primeira.url}>{primeira.instituto}</Externo>. {vista.outro_lado_aviso}
      </p>
    </Bloco>
  );
}
